import { appServiceName } from '../services/http';

const getUploadDocumentUrl = (documentPath) => {
  if (!documentPath) return null;
  if (documentPath.startsWith('http://') || documentPath.startsWith('https://')) {
    return documentPath;
  }

  let normalized = documentPath;
  if (normalized.startsWith('public/')) {
    normalized = normalized.substring(7);
  }
  normalized = normalized.startsWith('/') ? normalized : `/${normalized}`;
  return `${appServiceName}${normalized}`;
};

export default getUploadDocumentUrl;
